import PageContainer from '@/common/components/PageContainer'
import { AdminOperatorForm } from '@/modules/admin/components/AdminOperatorForm'

export default function CreateOperatorPage() {
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<AdminOperatorForm />
			</div>
		</PageContainer>
	)
}
